<ct-model-version-scenarios-grid
  #scenariosGrid
  [scenarios]="scenarios"
></ct-model-version-scenarios-grid>
